module.exports = __webpack_public_path__ + "img/pixing_xc1.3e9824e4.jpg";